









































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import Trigger from '@modules/ui/triggers/Trigger'
import ResourceList from '@modules/ui/List/ResourceList'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: 'POIResourceList'
  components: { Modal, Trigger, ResourceList, LoadingIndicator }

  vue:
    props: ['pois', 'actions', 'filtersOverriden', 'infiniteWrapper', 'options']

    data: ->
      filters:
        q: ''

      pageNumber: 1
      selectedPOIs: []
      selectedFilters: []

    mounted: ->
      @filters = @filtersOverriden if @filtersOverriden?

    computed:
      components: ->
        {
          'p-o-i-resource-list-item': () => import('./POIResourceListItem')
        }

      title: ->
        @options?.title || 'Points of Interest'

      resourceKey: ->
        @options?.resourceKey || 'pois'

    methods:
      hiInfiniteScroll: (state) ->
        @actions.fetchResource(state, @resourceKey, @filters, { page: @pageNumber })
        @pageNumber += 1

      hiFilterChange: (selectedFilters) ->
        @$refs.infiniteLoading.stateChanger.reset()
        @selectedFilters = selectedFilters if selectedFilters
        @pageNumber = 1
        @actions.fetchResource(null, @resourceKey, @filters, { page: @pageNumber })
        @pageNumber += 1

      hiClearFilter: ->
        cleared_filter_scope = @filters.scopes
        Object.keys(cleared_filter_scope).forEach((key) -> cleared_filter_scope[key] = null)
        @filters.scopes = cleared_filter_scope
        @hiFilterChange()

      hiSearchChange: (q = '') ->
        @filters.q = q
        @hiFilterChange()

export default VueOptions.vue settings
